import React, { createContext, useState } from 'react';

import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Home from './components/HomeComponent/home';
import Header from './components/Header/Header';
import ClassesPage from './Pages/ClassesPage/ClassesPage';
import ContactPage from './Pages/ContactPage/ContactPage';
import Footer from './components/Footer/Footer';
import EventPage from './Pages/EventPage/eventPage';
import GalleryPage from './Pages/GalleryPage/GalleryPage';
import AboutUsPage from './Pages/AboutUsPage/AboutUsPage';
import DanceClassesPage from './Pages/DanceClassesPage/DanceClassesPage';
import SummerCampPage from './Pages/SummerCamp/SummerCampPage';
import NatyaFusionPage from './Pages/NatyaFusionPage/NatyaFusionPage';
import ShirtOrderPage from './Pages/ShirtOrder/ShirtOrderPage';
import FifaFanFestPage from './Pages/FifaFanFestPage/FifaFanFestPage';


export const contextData = createContext();

function App() {

  const [isScrolled, setIsScrolled] = useState(false);

  return (
    <div className='w-full h-full bg-white'>
      <div className='h-full '>
        <contextData.Provider value={{isScrolled, setIsScrolled}}>
          <Router>
            <Header/>
            <Routes>
              <Route path='/' exact Component={Home} />
              <Route path='/classes' Component={ClassesPage} />
              <Route path='/contact' Component={ContactPage} />
              <Route path='/eventPage' Component={EventPage} />
              <Route path='/galleryPage' Component={GalleryPage} />
              <Route path='/aboutPage' Component={AboutUsPage} />
              <Route path='/danceClassPage' Component={DanceClassesPage} />
              <Route path='/summerCampPage' Component={SummerCampPage} />
              <Route path='/natyaFusionPage' Component={NatyaFusionPage} />
              <Route path='/shirtOrderPage' Component={ShirtOrderPage} />
              <Route path='/fifaFanFestPage' Component={FifaFanFestPage} />
            </Routes>
            <Footer/>
          </Router>
        </contextData.Provider>
      </div>
    </div>
  );
}

export default App;